import { EventName } from '@lit/react';
import { BlocksTableHeaderCell } from 'blocks-nextjs/blocks-web-components/components/table-header-cell/table-header-cell';
import { BlocksColumnSortEvent, BlocksRowCellSelectAllEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTableHeaderCell = createComponent({
  react: React,
  tagName: 'cat-table-header-cell',
  elementClass: BlocksTableHeaderCell,
  events: {
    onBlColumnSort: 'bl-column-sort' as EventName<BlocksColumnSortEvent>,
    onBlRowCellSelectAll: 'bl-row-cell-select-all' as EventName<BlocksRowCellSelectAllEvent>
  }
});
